import { render, staticRenderFns } from "./DashboardExample.vue?vue&type=template&id=43403bf0"
import script from "./DashboardExample.vue?vue&type=script&lang=js"
export * from "./DashboardExample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports